"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ListItem = _interopRequireDefault(require("../components/ListItem"));

var _NavPane = _interopRequireDefault(require("../components/NavPane"));

var _iconCaret = _interopRequireDefault(require("../../../shared/icons/icon-caret.svg"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var uuid = require('uuid/v4');

var MobileNavMenu = /*#__PURE__*/function (_React$Component) {
  _inherits(MobileNavMenu, _React$Component);

  var _super = _createSuper(MobileNavMenu);

  function MobileNavMenu(props) {
    var _this;

    _classCallCheck(this, MobileNavMenu);

    _this = _super.call(this, props);
    _this.goToNavPane = _this.goToNavPane.bind(_assertThisInitialized(_this));
    _this.goToRoot = _this.goToRoot.bind(_assertThisInitialized(_this));
    _this.closeNavMenu = _this.closeNavMenu.bind(_assertThisInitialized(_this));
    _this.state = {
      activePane: null,
      showRoot: true
    };
    return _this;
  }

  _createClass(MobileNavMenu, [{
    key: "goToNavPane",
    value: function goToNavPane(groupId) {
      this.setState({
        activePane: groupId,
        showRoot: false
      });
    }
  }, {
    key: "goToRoot",
    value: function goToRoot() {
      this.setState({
        activePane: null,
        showRoot: true
      });
    }
  }, {
    key: "closeNavMenu",
    value: function closeNavMenu(_ref) {
      var key = _ref.key;
      var _this$props = this.props,
          isOpen = _this$props.isOpen,
          toggleDrawerOpen = _this$props.toggleDrawerOpen;
      var escapeKeyPressed = key === 'Escape';

      if (isOpen && escapeKeyPressed) {
        toggleDrawerOpen();
      }
    }
  }, {
    key: "renderNavPanes",
    value: function renderNavPanes(navItem) {
      var _this2 = this;

      var navItemId = navItem.id,
          navItemName = navItem.name,
          subGroups = navItem.subGroups;
      var activePane = this.state.activePane; // Skip the L2 dive down if only one sub group present

      if (subGroups.length === 1) {
        var subGroup = subGroups[0];
        return /*#__PURE__*/_react["default"].createElement(_NavPane["default"], {
          key: uuid(),
          activePane: activePane,
          backItemId: navItemId,
          displayName: subGroup.name,
          paneId: "".concat(navItemId, "_subGroups"),
          navItems: subGroup.items,
          goToNavPane: this.goToNavPane,
          goToRoot: this.goToRoot
        });
      } // Render the L2 dive down when multiple sub groups present


      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_NavPane["default"], {
        key: uuid(),
        activePane: activePane,
        backItemId: navItemId,
        displayName: navItemName,
        paneId: "".concat(navItemId, "_subGroups"),
        navItems: subGroups,
        goToNavPane: this.goToNavPane,
        goToRoot: this.goToRoot
      }), subGroups.map(function (subGroup) {
        return /*#__PURE__*/_react["default"].createElement(_NavPane["default"], {
          key: uuid(),
          activePane: activePane,
          backItemId: "".concat(navItemId, "_subGroups"),
          displayName: subGroup.name,
          paneId: "".concat(navItemId, "_subGroups_").concat(subGroup.name),
          navItems: subGroup.items,
          goToNavPane: _this2.goToNavPane
        });
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var showRoot = this.state.showRoot;
      var _this$props2 = this.props,
          top = _this$props2.top,
          isOpen = _this$props2.isOpen,
          navItems = _this$props2.navItems;
      var drawerClass = (0, _classnames["default"])({
        'nav-drawer': true,
        'nav-drawer--open': isOpen
      });
      var positionUnderHeader = {
        height: "calc(100% - ".concat(top, "px)")
      };
      var tabIndex = isOpen ? '0' : '-1';
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: drawerClass,
        style: positionUnderHeader,
        "aria-label": "Mobile menu",
        role: "dialog"
      }, /*#__PURE__*/_react["default"].createElement("ul", {
        className: "nav-drawer__link-list",
        onKeyDown: this.closeNavMenu
      }, navItems.map(function (navItem) {
        var subGroups = navItem.subGroups || [];

        if (showRoot && subGroups.length <= 0) {
          return /*#__PURE__*/_react["default"].createElement(_ListItem["default"], _extends({
            key: navItem.id,
            tabIndex: tabIndex
          }, navItem));
        }

        return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
          key: uuid()
        }, showRoot && /*#__PURE__*/_react["default"].createElement("li", {
          className: "nav-drawer__link-list__item"
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "nav-drawer__link",
          role: "button",
          tabIndex: tabIndex,
          onClick: function onClick() {
            return _this3.goToNavPane("".concat(navItem.id, "_subGroups"));
          },
          onKeyPress: function onKeyPress() {
            return _this3.goToNavPane("".concat(navItem.id, "_subGroups"));
          }
        }, /*#__PURE__*/_react["default"].createElement("span", null, navItem.name), /*#__PURE__*/_react["default"].createElement(_iconCaret["default"], {
          className: "nav-drawer__caret"
        }))), _this3.renderNavPanes(navItem));
      })));
    }
  }]);

  return MobileNavMenu;
}(_react["default"].Component);

MobileNavMenu.propTypes = {
  top: _propTypes["default"].number.isRequired,
  isOpen: _propTypes["default"].bool.isRequired,
  toggleDrawerOpen: _propTypes["default"].func.isRequired,
  navItems: _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].shape({})])).isRequired
};
var _default = MobileNavMenu;
exports["default"] = _default;